/**
 * Sub-services "Trust bar": logo strip with dots and mobile auto-advance.
 */
document.addEventListener('DOMContentLoaded', function () {
    var track = document.getElementById('subservicesTrustLogosTrack');
    var dotsContainer = document.getElementById('subservicesTrustDots');
    if (!track) return;

    var items = track.querySelectorAll('.subservices-trust-bar__logo-item');
    var dots = dotsContainer ? dotsContainer.querySelectorAll('.trust-bar-dot') : [];
    if (items.length <= 1) return;

    var isPaused = false;
    var autoPlayTimer = null;
    var activeIdx = 0;

    function updateActiveUI(idx) {
        dots.forEach(function (dot, i) { dot.classList.toggle('active', i === idx); });
        items.forEach(function (item, i) { item.classList.toggle('is-active', i === idx); });
    }

    function scrollToSlide(idx) {
        var item = items[idx];
        if (!item) return;
        activeIdx = idx;
        var scrollOffset = item.offsetLeft - (track.clientWidth - item.clientWidth) / 2;
        track.scrollTo({ left: Math.max(0, scrollOffset), behavior: 'smooth' });
        updateActiveUI(idx);
    }

    // Update active dot based on scroll position
    var scrollTimeout;
    track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
            var trackCenter = track.scrollLeft + track.clientWidth / 2;
            var minDiff = Infinity;
            items.forEach(function (item, i) {
                var diff = Math.abs(trackCenter - (item.offsetLeft + item.clientWidth / 2));
                if (diff < minDiff) {
                    minDiff = diff;
                    activeIdx = i;
                }
            });
            updateActiveUI(activeIdx);
        }, 60);
    }, { passive: true });

    function startAutoPlay() {
        clearInterval(autoPlayTimer);
        // Auto advance only on mobile/tablet screens <= 767px
        autoPlayTimer = setInterval(function () {
            if (window.innerWidth <= 767 && !isPaused) {
                scrollToSlide((activeIdx + 1) % items.length);
            }
        }, 3500);
    }

    dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
            var target = parseInt(this.getAttribute('data-target-slide'), 10);
            if (!isNaN(target)) {
                scrollToSlide(target);
                startAutoPlay();
            }
        });
    });

    track.addEventListener('touchstart', function () { isPaused = true; }, { passive: true });
    track.addEventListener('touchend', function () {
        setTimeout(function () { isPaused = false; }, 2000);
    }, { passive: true });
    track.addEventListener('mouseenter', function () { isPaused = true; });
    track.addEventListener('mouseleave', function () { isPaused = false; });

    startAutoPlay();
});
